module.exports = __webpack_public_path__ + "img/download-primary.ff1bcf1d.svg";